import ProductReviewSettings from './ProductReviewSettings.svelte';

export let ProductReviewWidgetApi = {
  Settings: (target, widget, onChange, refreshUI) => {
    return new ProductReviewSettings({
      target: target,
      props: { widget: widget, onChange: onChange, refreshUI: refreshUI }
    });
  }
};
